// src/pages/ReturnPolicy.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ReturnPolicy = () => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: isArabic ? 'Cairo, sans-serif' : 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    direction: isArabic ? 'rtl' : 'ltr',
    textAlign: isArabic ? 'right' : 'left'
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ color: '#3498db', marginBottom: '30px' }}>
        {isArabic ? 'سياسة الاسترجاع والإلغاء' : 'Return & Cancellation Policy'}
      </h1>
      <p>{isArabic
        ? 'نحن نسعى لتقديم خدمة ممتازة لجميع عملائنا. تنطبق سياسة الإلغاء والاسترجاع التالية:'
        : 'We aim to provide excellent service. The following return and cancellation policy applies:'}</p>

      <ul style={{ lineHeight: '1.8', marginTop: '15px' }}>
        <li>{isArabic ? 'يمكنك إلغاء الطلب قبل أن يتم تأكيده من قبل المطعم.' : 'You can cancel the order before it is confirmed by the restaurant.'}</li>
        <li>{isArabic ? 'إذا تم تأكيد الطلب، لا يمكن الإلغاء إلا بموافقة المطعم.' : 'Once confirmed, cancellation is subject to restaurant approval.'}</li>
        <li>{isArabic ? 'إذا استلمت منتجًا غير مطابق، يرجى التواصل معنا خلال 24 ساعة.' : 'If you receive a wrong product, contact us within 24 hours.'}</li>
      </ul>

      <p style={{ marginTop: '30px', color: '#7f8c8d' }}>
        {isArabic
          ? 'للاستفسار، يرجى مراسلتنا عبر البريد info@atdelivery.net'
          : 'For inquiries, contact us at info@atdelivery.net'}
      </p>
    </div>
  );
};

export default ReturnPolicy;
